import Box from "@mui/material/Box";
import React, {useEffect, useState} from "react";
import {useTheme} from "../../contexts/theme";
import {useMamInformation} from "../../contexts/MamInformation";
import {useMamSummary} from "../../contexts/mamSummary";
import MatchDay from "./MatchDay";
import axiosInstance from "../../queries/axiosInstance";
import {indexOf, result} from "lodash";
import {useActiveFilters} from "../../contexts/activeFilters";
import {Competition} from "../../types/competitionTypes";
import MatchDaysMamSkeleton from "./MamSkeleton/MatchDaysMamSkeleton";


interface MatchDayContainerProps {
    competition: string;
}

export default function MatchDayContainer({competition}: MatchDayContainerProps) {


    const {information} = useMamInformation();
    const {setInformation, setUpdateLoading} = useMamInformation();

    const {activeFilters} = useActiveFilters();


    const {summary} = useMamSummary();
    const {setSummary} = useMamSummary();

    const [loadingEvent, setLoadingEvent] = useState(false);


    const getEventsOnDemand = async (matchDay_id: string) => {

        try {
            setUpdateLoading(true);
            const response = await axiosInstance.post('/assets/events', {
                competition: competition,
                matchDayId: matchDay_id,
                filters: activeFilters,
            });

            return response.data;
        } catch (errorCompetition) {
            console.error("Error retrieve events", JSON.stringify(errorCompetition));
        }finally {
            setUpdateLoading(false)
        }
    }

    const onCollapseOpen = (matchDay_id: string, openMatchDay: boolean) => {
        const tempSummary = {...summary};
        const tempInformation = {...information!};

        if (openMatchDay){
            tempSummary.matchDay = tempSummary.matchDay.filter(item => item !== matchDay_id);


            const tempEvent = tempInformation.matchDayEvents.filter(item => item.matchDayId === matchDay_id);

            if (tempEvent.length > 0) {
                tempEvent.map((match)=>{
                    tempInformation.matchDayEvents.splice(tempInformation.matchDayEvents.indexOf(match), 1);
                    tempSummary.match = tempSummary.match.filter(id => id !== match.id);

                    const clipGroup = tempInformation.clipGroups.filter(item => item.event_id === match.id)
                if (clipGroup.length > 0) {
                    clipGroup.map(item => {
                        tempInformation.clipGroups.splice(tempInformation.clipGroups.indexOf(item), 1);
                        const clips = tempInformation.clipGroups.filter(item => item.groupId === item.id);
                        if (clips.length > 0) {
                            clips.map(clip => {
                                tempInformation.clip.splice(tempInformation.clip.indexOf(clip), 1);
                            })

                        }
                    })

                }


              //  tempInformation.clip = tempInformation.clip.filter(item => item.groupId !== tempGroupClip.id);

                setInformation(tempInformation)
            })
            }





        }else {
            if (!tempSummary.matchDay.find(item => item === matchDay_id)) {
                const matchDays = [...tempSummary.matchDay];
                matchDays.push(matchDay_id);
                tempSummary.matchDay = matchDays;
                setLoadingEvent(true);
            }
            getEventsOnDemand(matchDay_id).then(result => {


                if (tempInformation.matchDayEvents) {
                    result.map((value: any) => {
                        if (!tempInformation.matchDayEvents.find((item: any) => item.id === value.id)) {
                            tempInformation.matchDayEvents.push(value);
                        }
                    })
                    setInformation(tempInformation)
                    setLoadingEvent(false)
                }

            })

        }
        setSummary(tempSummary);
    }

    useEffect(() => {
        if (information && information.matchDay) {
            const tempSummary = {...summary};

                for (const matchDay of information.matchDay) {

                    const matchDayEvent = information.matchDayEvents.find(match => match.matchDayId === matchDay.id);
                    if (matchDayEvent) {
                        if (!summary.matchDay.find((matchDayId => matchDayId === matchDay.id))) {
                            tempSummary.matchDay.push(matchDay.id);
                        }
                    }

                setSummary(tempSummary)
            }
        }
    }, [information?.matchDay]);


    return (


        <Box>



            {information?.matchDay && information?.matchDay?.filter(item => item.competitionId === competition).map((item, index) => (
                <MatchDay collapseOpen={Boolean(summary.matchDay.find(matchDayId => matchDayId === item.id))} matchDay={item} onCollapseOpen={onCollapseOpen} loading={loadingEvent} />
                    ))}
        </Box>
    );
}